module.exports = __webpack_public_path__ + "static/media/mc20-bg.10fe93af.jpg";